export const initHomePageHeader = () => {
  const homepage = document.getElementById("homepage");

  if (!homepage) {
    return;
  }

  const bodyTop = document.getElementById("body-top") as HTMLDivElement;
  const header = document.getElementById("header") as HTMLHeadElement;
  const searchExpandable = header.querySelector(".search-expandable") as HTMLDivElement;
  const homepageTopMenu = header.querySelector(".homepage-top-menu") as HTMLElement;

  function handleIntersect(entries: IntersectionObserverEntry[]) {
    // no intersection with screen
    if (entries[0].intersectionRatio === 0) {
      searchExpandable.classList.add("d-sm-flex");
      homepageTopMenu.classList.add("d-none");

      // fully intersects with screen
    } else if (entries[0].intersectionRatio === 1) {
      searchExpandable.classList.remove("d-sm-flex");
      homepageTopMenu.classList.remove("d-none");
    }
  }

  const observer = new IntersectionObserver(handleIntersect);

  observer.observe(bodyTop);
};
